import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">DIGITRONICKS</h3>
            <p className="footer-description">
              Your trusted partner in digital advertising and ad network solutions.
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <Mail size={18} />
                <a href="mailto:info@digitronicks.com">info@digitronicks.com</a>
              </div>
              <div className="footer-contact-item">
                <Phone size={18} />
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>Global Ad Network</span>
              </div>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <nav className="footer-nav">
              <a href="#overview">Overview</a>
              <a href="#domains">Domains</a>
              <a href="#services">Services</a>
              <a href="#clients">Clients</a>
            </nav>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Digitronicks. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;